const ENDPOINTS = {
  byIp: (params = '') => `get-country-by-ip/?${params}`,
};

export {ENDPOINTS};
